import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import UserAnalytics from "@/components/admin/users/UserAnalytics";
import UserList from "@/components/admin/users/UserList";
import UserVerification from "@/components/admin/users/UserVerification";
import UserRiskAssessment from "@/components/admin/users/UserRiskAssessment";

const UserManagement = () => {
  return (
    <div className="space-y-6 p-6 lg:p-8">
      <Card className="p-6">
        <Tabs defaultValue="analytics" className="space-y-6">
          <TabsList className="w-full justify-start border-b pb-0">
            <TabsTrigger value="analytics" className="data-[state=active]:border-b-2">
              Analytics
            </TabsTrigger>
            <TabsTrigger value="users" className="data-[state=active]:border-b-2">
              Users List
            </TabsTrigger>
            <TabsTrigger value="verification" className="data-[state=active]:border-b-2">
              Verification
            </TabsTrigger>
            <TabsTrigger value="risk" className="data-[state=active]:border-b-2">
              Risk Assessment
            </TabsTrigger>
          </TabsList>

          <TabsContent value="analytics" className="space-y-6">
            <UserAnalytics />
          </TabsContent>

          <TabsContent value="users" className="space-y-6">
            <UserList />
          </TabsContent>

          <TabsContent value="verification" className="space-y-6">
            <UserVerification />
          </TabsContent>

          <TabsContent value="risk" className="space-y-6">
            <UserRiskAssessment />
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  );
};

export default UserManagement;